import { Theme } from 'styling/theme'
import { WORD_FLOW_ANIMATION_DURATION_MS } from 'redux/slices/wordFlow'
import { interactionWidgetHeight } from 'components/set/InteractionWidget/styles'
import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) => ({
    wordFlow: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        background: '#16181f',
        overflowX: 'hidden',
    },
    header: {
        display: 'flex',
        background: theme.colors.black,
        height: 54,
    },
    closeBtn: {
        border: 'none',
        background: 'transparent',
        color: 'white',
        marginLeft: 20,
    },
    backBtnIcon: {
        marginRight: 16,
    },
    backBtnText: {
        fontSize: 18,
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,
    },
    content: {
        flex: 1,
        display: 'flex',
        alignItems: 'flex-end',
        position: 'relative',
        overflow: 'hidden',
    },
    footer: {
        background: '#1c1f26',
        padding: 10,
        position: 'absolute',
        bottom: 0,
        width: '100%',
        zIndex: 1000,

        '@media (max-width: 767px)': {
            position: 'fixed',
        },
    },
    form: {
        display: 'flex',
    },
    input: {
        border: 0,
        height: 40,
        width: '100%',
        borderRadius: 20,
        background: '#33353a',
        padding: '10px 16px',
        outline: 0,
    },
    wordList: {
        padding: 0,
        margin: 0,
        listStyle: 'none',
    },
    wordItem: {
        '--travelDistance': '-600px',
        opacity: 'var(--opacity)',
        animation: `$disperse ${WORD_FLOW_ANIMATION_DURATION_MS}ms linear`,
        position: 'absolute',
        display: 'flex',
        padding: '0 16px',

        '@media (max-width: 767px)': {
            '--travelDistance': `calc(${interactionWidgetHeight} - 60px - 100vh)`,
        },
    },
    word: {
        border: 0,
        background: '#34373c',
        color: '#fff',
        fontSize: 12,
        fontFamily: theme.typographyPresets.fonts.notoSans.bold,
        borderRadius: 20,
        display: 'inline-block',
        padding: '13px 16px',
        marginLeft: 'auto',
        whiteSpace: 'nowrap',
        boxShadow: '1px 1px 5px rgba(0, 0, 0, .8)',
        position: 'relative',
        transition: 'background 0s .4s',

        '&::before': {
            content: '""',
            display: 'inline-block',
            height: '20px',
            width: '20px',
            position: 'absolute',
            borderRadius: '50%',
            background: '#ffc908',
            transition: 'transform .4s ease, opacity .6s ease',
            top: '50%',
            right: '50%',
            transform: 'translate(50%, -50%)',
            opacity: 0.5,
            visibility: 'hidden',
        },
    },
    wordHighlighted: {
        background: theme.gradients.yellowToPink,
        boxShadow: '1px 1px 5px rgba(0, 0, 0, .8)',

        '&::before': {
            transform: 'translate(50%, -50%) scale(5)',
            visibility: 'visible',
            opacity: '0',
        },
    },
    submitBtn: {
        background: '#33353a',
        border: 0,
        borderRadius: '50%',
        fontSize: 18,
        minWidth: 40,
        lineHeight: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 8,

        '@media (min-width: 768px)': {
            display: 'none',
        },
    },
    warningBanner: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: 6,
        backgroundColor: theme.colors.brand.blue,
        color: 'white',
        fontFamily: theme.typographyPresets.fonts.notoSans.bold,
        fontSize: '13px',
        fontWeight: 'bold',
        padding: '15px 16px',
        margin: 16,
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.5)',
        zIndex: 1000,

        '@media (max-width: 767px)': {
            padding: '10px 8px',
            fontSize: '11px',
        },
    },
    warningIcon: {
        marginRight: 16,
    },
    dismissButton: {
        background: '0',
        color: 'white',
        border: '0',
        fontSize: '19px',
        padding: '0 10px',
    },
    '@keyframes disperse': {
        '0%': {
            transform: 'translateY(0)',
        },
        '80%': {
            opacity: 'var(--opacity)',
        },
        '100%': {
            opacity: 0,
            transform: 'translateY(var(--travelDistance))',
        },
    },
}))
